'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import {
  Container,
  Typography,
  Box,
  CircularProgress,
  Button
} from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import Link from 'next/link'

export default function Home() {
  const { user, loading: authLoading } = useAuth()
  const router = useRouter()

  // Redirect to appropriate dashboard after successful login
  useEffect(() => {
    if (!authLoading) {
      if (user) {
        // Use replace instead of push to avoid adding to history
        if (user.role === 'vendor') {
          router.replace('/vendor/dashboard')
        } else if (user.role === 'consumer') {
          router.replace('/consumer/dashboard')
        }
      } else {
        // Redirect to login page if not authenticated
        router.replace('/auth/login')
      }
    }
  }, [user, authLoading, router])

  // Show minimal loading while redirecting
  // Use a lighter loading state to reduce visual impact
  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      minHeight="100vh"
      sx={{ bgcolor: 'background.default' }}
    >
      {/* Empty - will redirect immediately */}
    </Box>
  )
}
